module.exports = __webpack_public_path__ + "img/styria-marketplaces.e9b8b885.svg";